import Toast from "./toast";
import Confirm from "./confirm";

// let ToastInstance = null;
function getToastInstance(options) {
    // ToastInstance = Toast.newInstance(options);
    // return ToastInstance;
    return Toast.newInstance(options);
}

let ConfirmInstance = null;
function getConfirmInstance(options) {
    ConfirmInstance = ConfirmInstance || Confirm.newInstance(options);
    return ConfirmInstance;
}
function install(Vue, option = {}) {
    Vue.prototype.$toast = function(content, duration = 2000, cb) {
        let toastInstance = getToastInstance();
        toastInstance.setContent(content);
        toastInstance.show();
        let timer = setTimeout(() => {
            toastInstance.destroy();
            clearTimeout(timer);
            timer = null;
            typeof cb === "function" && cb.apply(this);
        }, duration);
        return toastInstance;
    };
    /**
     * prams {
     *     prefixCls      //tm-modal样式 已经有了
     *     className      //自定义样式
     *     closeAble      //是否有左上角关闭按钮
     *     maskCloseAble  //是否能点击遮罩 关闭弹窗
     *     title          //标题
     *     okText         // 确认按钮的文案
     *     cancelText     //取消按钮的文案
     *     showHead       //是否显示头部
     *     mask           //是否显示遮罩
     *     zIndex         // 弹窗的z-index
     *
     * }
     *
     * **/
    Vue.prototype.$confirm = function(prams) {
        let options = {
            prefixCls: "tm-modal",
            className: "tm-confirm",
            closeAble: true,
            maskCloseAble: false,
            title: "标题",
            okText: "确定",
            ok() {},
            content: "confirm内容",
            cancelText: "取消",
            cancel() {
                this.close();
            },
            showHead: true,
            mask: true,
            zIndex: 1000,
            showCancel: true
        };
        Object.assign(options, prams);
        return getConfirmInstance(options);
    };
}
export default {
    install
};
